import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, postDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";
import { get_folder_thunk } from "../folder/folderThunk";
import { get_todo_thunk } from "../todo/todoThunk";
import { sync_data_thunk } from "../auth/authThunk";

export const create_or_update_opentab_thunk = createAsyncThunk('user/opentab/create_or_update_opentab', async (tempData, thunkAPI) => {
    try {


        let body = {
            opentabs: tempData.data
        }
        await postDataAPI('user/opentab/create_or_update_opentab', body, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const get_opentabs_thunk = createAsyncThunk('user/opentab/get_opentabs', async (tempData, thunkAPI) => {
    try {

        const response = await getDataAPI('user/opentab/get_opentabs', tempData.token);
        localStorage.setItem(`openTabs`, JSON.stringify(response.data.data.response));
        return response.data
    } catch (error) {
        console.log('error', error)
        // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})